import { LabeledValue } from "@risalabs_frontend_org/oasis-ui-kit";
import "./CollapsiblePatientCard.scss";

interface CollapsibleCardField {
  label: string;
  value: string;
}

/**
 * Expandable patient-strip grid under the eligibility details header.
 *
 * @param props.data - Labeled fields from the detail patient strip
 * @param props.isExpanded - Whether the strip is shown
 * @returns Collapsible labeled-value grid
 */
const CollapsiblePatientCard = ({
  isExpanded = false,
  data,
}: {
  data: CollapsibleCardField[];
  isExpanded?: boolean;
}) => {
  return (
    <div
      className={`single-patient-collapsable-card bg-white${
        isExpanded ? " single-patient-collapsable-card--expanded" : ""
      }`}
    >
      <div className="single-patient-collapsable-card--container border-b">
        {data.map(({ label, value }) => (
          <LabeledValue
            key={label}
            label={label}
            value={value}
            direction="horizontal"
            truncate
            title={value}
            className="single-patient-collapsable-card__field min-w-0"
            labelClassName="shrink-0 font-normal text-x-tiny"
            valueClassName="min-w-0 font-semibold text-x-small"
          />
        ))}
      </div>
    </div>
  );
};

export default CollapsiblePatientCard;
